'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var styles = {
  widgetContainer: {
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    margin: '0 20px 20px 0',
    position: 'fixed',
    right: 0,
    zIndex: 9999
  },
  fullscreen: {
    height: '100%',
    margin: 0,
    width: '100%'
  }
};

exports.default = styles;